var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"numberspilt-box"},_vm._l((_vm.splitNumerStr(_vm.val)),function(item,index){return _c('div',{key:'num_split' + index,staticClass:"numberspilt-box-item"},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }